import React, { Component } from 'react'
import { Spin, Alert } from 'antd';

export default class Loading extends Component {
    render() {
        return (
            <div className="text-center">
            <Spin> </Spin><br/>
            <p className="text-primary">ระบบกำลังโหลดข้อมูลใหม่ล่าสุด กรุณารอสักครู่</p>
       </div>
        )
    }
}

